<span *ngIf="status == availabilityStatus.NOT_CHECKED" class="m-badge m-badge--metal m-badge--wide">Nepreverjen termin</span>

<span *ngIf="status == availabilityStatus.FREE" class="m-badge m-badge--accent m-badge--wide">Prosti termin</span>

<span *ngIf="status == availabilityStatus.OCCUPIED" class="m-badge m-badge--warning m-badge--wide">Termin je že zaseden</span>

<span *ngIf="status == availabilityStatus.BOOKED" class="m-badge m-badge--success m-badge--wide">Rezerviran</span>
